import { INewsletterPopupData } from './model';
import { getParent } from '../helper/helper';

const BASE_SELECTOR: string = "[data-sidebar]";

//Top Variablen
const TOP_SELECTOR: string = "[data-sidebar-top]";

//Phone Variablen
const PHONE_SELECTOR: string = "[data-sidebar-phone]";
const PHONE_BASE_SELECTOR: string = "[data-phone-base]";
const PHONE_BOX_SELECTOR: string = "[data-phone-box]";
const PHONE_CLOSE_SELECTOR: string = "[data-phone-close]";

//Event Variablen
const EVENT_SELECTOR: string = "[data-sidebar-event]";
const EVENT_BASE_SELECTOR: string = "[data-event-base]";
const EVENT_BOX_SELECTOR: string = "[data-event-box]";
const EVENT_STRIPE_SELECTOR: string = "[data-event-stripe]";
const EVENT_CLOSE_SELECTOR: string = "[data-event-close]";

//Newsletter Variablen
const NEWSLETTER_SELECTOR: string = "[data-sidebar-newsletter]";
const POPUP_BASE_SELECTOR: string = "[data-popup-base]";
const POPUP_BOX_SELECTOR: string = "[data-popup-box]";
const POPUP_STRIPE_SELECTOR: string = "[data-popup-stripe]";
const POPUP_CLOSE_SELECTOR: string = "[data-popup-close]";
const IS_ACTIVE_CLASSNAME: string ="is-active";
const FORM_SELECTOR: string = "[data-newsletter-form]";
const LOAD_SELECTOR: string = "[data-newsletter-load]";
export const INVALID_CLASSNAME: string = 'is-invalid';

export class SidebarUI {

  public constructor(private $base: HTMLElement) {
  }

  //Top Button JS

  public clickTopButton (callback) {
    this.$base.querySelector(TOP_SELECTOR).addEventListener('click', () => {
      this.$base.querySelector(TOP_SELECTOR).classList.add('is-clicked');
      callback();
    });
  }

  public smoothScroll () {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  //Event JS

  /* public clickEventButton (callback) {
    this.$base.querySelector(EVENT_SELECTOR).addEventListener('click', () => {
      this.$base.querySelector(EVENT_SELECTOR).classList.toggle('is-open');
      callback();
    });
  } */

  public clickEventButton (callback) {
    const el = this.$base.querySelector(EVENT_SELECTOR);
    if (el) {
      el.addEventListener('click', () => {
        el.classList.toggle('is-open');
        callback();
      });
    }
  }

  /* public clickEventClose(callback) {
    this.$base.querySelector(EVENT_CLOSE_SELECTOR).addEventListener('click', () => {
        this.$base.querySelector(EVENT_SELECTOR).classList.toggle('is-open');
        callback();
    });
  } */

  public clickEventClose (callback) {
    const el = this.$base.querySelector(EVENT_CLOSE_SELECTOR);
    if (el) {
      el.addEventListener('click', () => {
        el.classList.toggle('is-open');
        callback();
      });
    }
  }

 /*  public showContentEvent() {
     this.$base.querySelector(EVENT_BOX_SELECTOR).classList.add(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(EVENT_STRIPE_SELECTOR).classList.add(IS_ACTIVE_CLASSNAME);
    this.yx$base.querySelector(EVENT_BASE_SELECTOR).classList.add("fadeInRight");
    thisy.$base.querySelector(EVENT_BASE_SELECTOR).classList.add("go"); 
  }*/

  public showContentEvent() {
    const el = this.$base.querySelector(EVENT_BOX_SELECTOR);
    const el2 = this.$base.querySelector(EVENT_STRIPE_SELECTOR);
    const el3 = this.$base.querySelector(EVENT_BASE_SELECTOR);
    if (el) {
      el.classList.add(IS_ACTIVE_CLASSNAME);
      el2.classList.add(IS_ACTIVE_CLASSNAME);
      el3.classList.add('fadeInRight');
      el3.classList.add('go');
    }
  }

  /*public closeContentEvent() {
     this.$base.querySelector(EVENT_BOX_SELECTOR).classList.remove(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(EVENT_STRIPE_SELECTOR).classList.remove(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(EVENT_BASE_SELECTOR).classList.remove("fadeInRight");
    this.$base.querySelector(EVENT_BASE_SELECTOR).classList.remove("go"); 
  }*/
  
  public closeContentEvent() {
    const el = this.$base.querySelector(EVENT_BOX_SELECTOR);
    const el2 = this.$base.querySelector(EVENT_STRIPE_SELECTOR);
    const el3 = this.$base.querySelector(EVENT_BASE_SELECTOR);
    if (el) {
      el.classList.remove(IS_ACTIVE_CLASSNAME);
      el2.classList.remove(IS_ACTIVE_CLASSNAME);
      el3.classList.remove('fadeInRight');
      el3.classList.remove('go');
    }
  }

  //Phone Number JS

  public clickPhoneButton (callback) {
    this.$base.querySelector(PHONE_SELECTOR).addEventListener('click', () => {
      this.$base.querySelector(PHONE_SELECTOR).classList.toggle('is-open');
      callback();
    });
  }

  public clickPhoneClose(callback) {
    this.$base.querySelector(PHONE_CLOSE_SELECTOR).addEventListener('click', () => {
        this.$base.querySelector(PHONE_SELECTOR).classList.toggle('is-open');
        callback();
    });
  }

  public showContentPhone() {
    this.$base.querySelector(PHONE_BOX_SELECTOR).classList.add(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(PHONE_BASE_SELECTOR).classList.add("fadeInRight");
    this.$base.querySelector(PHONE_BASE_SELECTOR).classList.add("go");
  }

  public closeContentPhone() {
    this.$base.querySelector(PHONE_BOX_SELECTOR).classList.remove(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(PHONE_BASE_SELECTOR).classList.remove("fadeInRight");
    this.$base.querySelector(PHONE_BASE_SELECTOR).classList.remove("go");
  }

  //Newsletter JS
  public allowShow: boolean = true;

  public clickNewsletterButton (callback) {
    this.$base.querySelector(NEWSLETTER_SELECTOR).addEventListener('click', () => {
      this.$base.querySelector(NEWSLETTER_SELECTOR).classList.toggle('is-open');
      callback();
    });
  }

  public clickNewsletterClose(callback) {
    this.$base.querySelector(POPUP_CLOSE_SELECTOR).addEventListener('click', () => {
        this.$base.querySelector(NEWSLETTER_SELECTOR).classList.toggle('is-open');
        callback();
    });
  }

  public showContentNewsletter () {
    this.$base.querySelector(POPUP_BOX_SELECTOR).classList.add(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(POPUP_STRIPE_SELECTOR).classList.add(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(POPUP_BASE_SELECTOR).classList.add("fadeInRight");
    this.$base.querySelector(POPUP_BASE_SELECTOR).classList.add("go");
  }

  public closeContentNewsletter () {
    this.$base.querySelector(POPUP_BOX_SELECTOR).classList.remove(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(POPUP_STRIPE_SELECTOR).classList.remove(IS_ACTIVE_CLASSNAME);
    this.$base.querySelector(POPUP_BASE_SELECTOR).classList.remove("fadeInRight");
    this.$base.querySelector(POPUP_BASE_SELECTOR).classList.remove("go");
  }

  public onSubmit(callback: (data: INewsletterPopupData) => {}): void {

    if(this.$base.querySelector(FORM_SELECTOR)) {

        this.$base.querySelector(FORM_SELECTOR).addEventListener('submit', (e) => {

            const email = this.$base.querySelector("input[name='EMAIL']") as HTMLInputElement;
            const interest = this.$base.querySelector("input[name='ignore_interests']") as HTMLInputElement;
            const firstname = this.$base.querySelector("input[name='FNAME']") as HTMLInputElement;
            const lastname = this.$base.querySelector("input[name='LNAME']") as HTMLInputElement;
            const company = this.$base.querySelector("input[name='FIRMA']") as HTMLInputElement;
            const position = this.$base.querySelector("input[name='POSITION']") as HTMLInputElement;
            const companysize = this.$base.querySelector("select[name='FGROESSE']") as HTMLInputElement;
            const title = this.$base.querySelector("select[name='ANREDE']") as HTMLInputElement;
            const industry = this.$base.querySelector("select[name='BRANCHE']") as HTMLInputElement;
            const business = this.$base.querySelector("select[name='B2B2C']") as HTMLInputElement;
            const source = this.$base.querySelector("input[name='QUELLE']") as HTMLInputElement;
            const medium = this.$base.querySelector("input[name='MEDIUM']") as HTMLInputElement;
            const term = this.$base.querySelector("input[name='TERM']") as HTMLInputElement;
            const campaign = this.$base.querySelector("input[name='KAMPAGNE']") as HTMLInputElement;
            const content = this.$base.querySelector("input[name='CONTENT']") as HTMLInputElement;
            const referrer = this.$base.querySelector("input[name='REFERER']") as HTMLInputElement;

            const data: INewsletterPopupData = {
                email: email.value as string,
                interest: interest.value as string,
                firstname: firstname.value as string,
                lastname: lastname.value as string,
                company: company.value as string,
                position: position.value as string,
                companysize: companysize.value as string,
                title: title.value as string,
                industry: industry.value as string,
                business: business.value as string,
                source: source.value as string,
                medium: medium.value as string,
                term: term.value as string,
                campaign: campaign.value as string,
                content: content.value as string,
                referer: referrer.value as string
            }

            if (this.checkValidity()) {
                this.$base.querySelector(LOAD_SELECTOR).classList.add('is-active');
                callback(data);
            }
            event.preventDefault();
            return false;
        });
    }
}

public checkValidity() {
    const requiredElements: HTMLElement[] = [
        this.$base.querySelector("input[name='EMAIL']"),
    ]

    const validation = requiredElements.map((el) => {
        const element = el as HTMLInputElement

        if(el.getAttribute('id') == 'mce-EMAIL') {
            const pattern : any = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const email = element.value;

            if (!pattern.test(email)) {
                getParent(el, '.input__group').querySelector('.input__group__error').innerHTML = 'Die E-Mail Adresse ist ungültig.'
                getParent(el, '.input__group').querySelector('.input__group__error').classList.remove('is-hidden');
                this.addError(el);
                return false;
            }
        }

        if  (element.value === ''){
            this.addError(el);
            this.$base.querySelector(".newsletter__error__text").innerHTML = 'Ein Fehler ist aufgetreten. Bitte überprüfe deine Eingaben.';
            this.$base.querySelector(".newsletter__error").classList.remove('is-hidden');
            return false;
        } else {
            this.removeError(el);
            this.$base.querySelector(".newsletter__error").classList.add('is-hidden');
        }

        return true;
    });

    for (let index = 0; index < validation.length; index++) {
        const element = validation[index];
        if (!element) {
          // validation failed
          return false;
        }
      }
      // validation was successfully
      return true;
}

public addError($el: HTMLElement): void {
    $el.classList.add(INVALID_CLASSNAME);
    getParent($el, '.input__group').querySelector('.input__group__error').classList.remove('is-hidden');
}

public removeError($el: HTMLElement): void {
    $el.classList.remove(INVALID_CLASSNAME);
    getParent($el, '.input__group').querySelector('.input__group__error').classList.add('is-hidden');
}

public onError(error) {
    this.$base.querySelector(LOAD_SELECTOR).classList.remove('is-active');
    if (error.response.status == 400) {
        if (error.response.statusText == 'Member exists') {
            this.$base.querySelector('.newsletter__error').innerHTML = 'Diese E-Mail Adresse ist bereits registriert.';
            this.$base.querySelector("input[name='EMAIL']").classList.add(INVALID_CLASSNAME);
        } else {
            this.$base.querySelector('.newsletter__error').innerHTML = 'Die Daten konnten nicht verarbeitet werden. Überprüfe nochmal deine Eingaben, eventuell ist deine E-Mail Adresse bereits registriert. Bitte kontaktiere uns per E-Mail unter info@crowdmedia.de.';
            this.$base.querySelector("input[name='EMAIL']").classList.add(INVALID_CLASSNAME);
        }
    } else if (error.response.status == 500) {
        this.$base.querySelector('.newsletter__error').innerHTML = 'Wir haben gerade Probleme mit unserem Server. Bitte versuche es später nochmal oder kontaktiere uns per E-Mail unter info@crowdmedia.de.';
        this.$base.querySelector("input[name='EMAIL']").classList.add(INVALID_CLASSNAME);
    } else if (error.response.status == 429) {
        this.$base.querySelector('.newsletter__error').innerHTML = 'Du hast die maximale Anzahl an Anmeldungen überschritten. Bitte versuche es später nochmal oder kontaktiere uns per E-Mail unter info@crowdmedia.de.';
        this.$base.querySelector("input[name='EMAIL']").classList.add(INVALID_CLASSNAME);
    }  else if (error.response.status != 'undefined') {
        this.$base.querySelector('.newsletter__error').innerHTML = 'Ein Fehler ist aufgetreten. Bitte melde dich bei uns per E-Mail unter info@crowdmedia.de, damit wir dich eintragen können.';
        this.$base.querySelector("input[name='EMAIL']").classList.add(INVALID_CLASSNAME);
    }
    document.querySelector("#newsletter-error").classList.remove('is-hidden');
}

public onSuccess() {
    this.$base.querySelector('.newsletter__box__content__form').classList.add('is-hidden');
    this.$base.querySelector('.newsletter__content__success').classList.remove('is-hidden');
    this.$base.querySelector('.newsletter__box__content__headline').classList.add('is-hidden');
    this.$base.querySelector('.newsletter__box__content__text').classList.add('is-hidden');
}

public fillHiddenFields() {
    if(this.$base.querySelector("input[name='KAMPAGNE']")) {
        const campaign = localStorage.getItem('cookieCampaign') as string;
        const source = localStorage.getItem('cookieSource') as string;
        const medium = localStorage.getItem('cookieMedium') as string;
        const content = localStorage.getItem('cookieContent') as string;
        const term = localStorage.getItem('cookieTerm') as string;
        const referrer = localStorage.getItem('cookieReferer') as string;

        const campaignInput = { htmlElement: this.$base.querySelector("input[name='KAMPAGNE']") as HTMLInputElement, value: '' };
        const sourceInput = { htmlElement: this.$base.querySelector("input[name='QUELLE']") as HTMLInputElement, value: '' };
        const mediumInput = { htmlElement: this.$base.querySelector("input[name='MEDIUM']") as HTMLInputElement, value: '' };
        const contentInput = { htmlElement: this.$base.querySelector("input[name='CONTENT']") as HTMLInputElement, value: '' };
        const termInput = { htmlElement: this.$base.querySelector("input[name='TERM']") as HTMLInputElement, value: '' };
        const referrerInput = { htmlElement: this.$base.querySelector("input[name='REFERER']") as HTMLInputElement, value: '' };

        if (campaign) {
            campaignInput.htmlElement.value = campaign;
        } else {
            campaignInput.htmlElement.value = '';
        }

        if (source) {
            sourceInput.htmlElement.value = source;
        } else {
            sourceInput.htmlElement.value = '';
        }

        if (medium) {
            mediumInput.htmlElement.value = medium;
        } else {
            mediumInput.htmlElement.value = '';
        }

        if (content) {
            contentInput.htmlElement.value = content;
        } else {
            contentInput.htmlElement.value = '';
        }

        if (term) {
            termInput.htmlElement.value = term;
        } else {
            termInput.htmlElement.value = '';
        }

        if (referrer) {
            referrerInput.htmlElement.value = referrer;
        } else {
            referrerInput.htmlElement.value = '';
        }
    }
}
}


export function createSidebarUI() {
    const $base = document.querySelectorAll(BASE_SELECTOR);
    let uiInstances: SidebarUI[] = [];

    for (let index = 0; index < $base.length; index++) {
      const element = $base[index] as HTMLElement;
      uiInstances.push(new SidebarUI(element));
    }

    return uiInstances;
}
